import { LoaderFunction } from "react-router-dom";
import { medicationTitrationsApi } from "src/api/services/medicationTitrationsApi";
import { store } from "src/api/store";

export const medicationTitrationsLoader: LoaderFunction = ({ params }) => {
  if (params.titrationId != null) {
    return store
      .dispatch(
        medicationTitrationsApi.endpoints.getMedicationTitrations.initiate({
          titration_id: Number(params.titrationId),
        }),
      )
      .unwrap();
  }
};
